function getSegments(pathname = '/') {
  const path = pathname || '/';
  return path.split('/').filter(Boolean);
}

export function getTutorialTypeKey(pathname = '/') {
  const seg = getSegments(pathname);
  const root = seg[0] || 'root';
  if (root === 'is-emri') {
    // Detay: /is-emri/<id>
    if (seg.length >= 2) return 'is-emri-detail';
    return 'is-emri-list';
  }
  if (root === 'proje') {
    if (seg[1] === 'olustur') return 'proje-create';
    if (seg.length >= 2) return 'proje-detail';
    return 'proje-list';
  }
  if (root === 'servis') {
    if (seg.length >= 2) return 'servis-detail';
    return 'servis-list';
  }
  if (root === 'bayi') {
    if (seg.length >= 2) return 'bayi-detail';
    return 'bayi-list';
  }
  if (root === 'musteriler') {
    if (seg.length >= 2) return 'musteri-detail';
    return 'musteri-list';
  }
  if (root === 'unit') {
    if (seg.length >= 2) return 'unit-detail';
    return 'unit-list';
  }
  if (root === 'account') {
    return 'account';
  }
  if (root === 'giris') {
    if (seg[1] === 'unuttum') return 'giris-unuttum';
    if (seg[1] === 'sifirla') return 'giris-sifirla';
    return 'giris';
  }
  if (root === 'sorgu') {
    return 'sorgu';
  }
  if (root === 'calisanlar') {
    return 'calisanlar-list';
  }
  if (root === 'calisan-ekle') {
    return 'calisan-ekle';
  }
  return root;
}

export function getTutorialStorageKey(pathname = '/') {
  const type = getTutorialTypeKey(pathname);
  return `tutorialSeen:${type}`;
}

export function getTutorialSteps(pathname = '/') {
  const path = pathname || '/';
  const startsWith = (p) => path.startsWith(p);
  const seg = getSegments(path);

  if (startsWith('/ana-sayfa/')) {
    return [
      { title: 'Dashboard', description: 'Genel bakış ve hızlı erişim alanı: Bu sayfadan ihtiyaç duyduğunuz verilere hızlı ve kolay şekilde ulaşabilirsiniz.' },
      { title: 'Navigasyon', description: 'Sol/üst menülerle sayfalar arası geçiş yapın.' },
    ];
  }
  // İş Emri: Liste vs Detay ayrımı
  if (seg[0] === 'is-emri') {
    if (seg.length >= 2) {
      // Detay sayfası (/is-emri/<id>) — Buton bazlı öğretici
      return [
        { title: 'Proje Atama', description: 'İş emrini üniteye atayın ya da mevcut atamayı değiştirin.', dataId: 'assign-unit' },
        { title: 'İşi başlat', description: 'Aksiyon butonları ile işin durumunu ilerletin.', dataId: 'action-start' },
        { title: 'Alt Görev Ekle', description: 'Alt görev ekleyerek işin daha küçük parçalarına bölünmesini sağlayın. Alt görev sayesinde takımlarınıza iş verebilirsiniz', dataId: 'subtask' },
        { title: 'Çoklu Görev Ekle', description: 'Birden fazla görevi toplu olarak ekleyin.', dataId: 'bulk-task' },
      ];
    }
    // Liste sayfası (/is-emri/)
    return [
      { title: 'İş Emirleri', description: 'Bu sayfa, sizin için hazırlanmış işleri tablo şeklinde listeler.' },
      { title: 'Detay', description: 'Tablodaki ilgili satıra tıklayarak işin detaylarını görebilirsiniz.' },
    ];
  }
  // Proje
  if (seg[0] === 'proje') {
    if (seg[1] === 'olustur') {
      return [
        { title: 'Proje Oluştur', description: 'Proje bilgilerini girin ve kaydedin.' },
        { title: 'Alanlar', description: 'Başlık, açıklama ve sorumlu gibi alanları doldurun.' },
      ];
    }
    if (seg.length >= 2) {
      return [
        { title: 'Proje Detayı', description: 'Proje bilgileri, durum ve ilişkili kayıtları görüntüleyin.' },
        { title: 'İlişkili Görevler', description: 'Proje ile ilişkili görev ve iş emirlerini takip edin.' },
      ];
    }
    return [
      { title: 'Projeler', description: 'Proje listesini filtreleyin ve detaylara girin.' },
      { title: 'Yeni Proje', description: 'Projeyi başlatmak için proje ekle butonunu kullanın.' },
    ];
  }
  // Servis
  if (seg[0] === 'servis') {
    if (seg.length >= 2) {
      return [
        { title: 'Servis Detayı', description: 'Servis bilgilerini ve ilişkili kayıtları inceleyin.' },
        { title: 'İşlemler', description: 'Güncelleme ve ilişkilendirme işlemlerini gerçekleştirin.' },
      ];
    }
    return [
      { title: 'Servis Listesi', description: 'Servis kayıtlarını filtreleyin ve seçin.' },
      { title: 'Detay', description: 'Servis satırına tıklayarak detayına gidin.' },
    ];
  }
  // Bayi
  if (startsWith('/bayi/')) {
    if (seg.length >= 2) {
      return [
        { title: 'Bayi Detayı', description: 'Bayi bilgilerini, takımları ve ilişkili kayıtları görüntüleyin.' },
        { title: 'Hiyerarşi', description: 'Bayi ağındaki konumu ve ilişkilerini inceleyin.' },
      ];
    }
    return [
      { title: 'Bayi Ağı', description: 'Hiyerarşik yapı ve bayi detaylarına erişin.' },
      { title: 'Takımlar', description: 'Bayiye bağlı takımları yönetin ve görüntüleyin.' },
      { title: 'İş Yükü', description: 'Açık iş emirleri ve istatistiklere göz atın.' },
    ];
  }
  // Müşteriler
  if (seg[0] === 'musteriler') {
    if (seg.length >= 2) {
      return [
        { title: 'Müşteri Detayı', description: 'Müşteri bilgileri, adres ve ilişkili kayıtları görüntüleyin.' },
        { title: 'İlişkili Kayıtlar', description: 'Biletler, servisler ve aktiviteleri takip edin.' },
      ];
    }
    return [
      { title: 'Müşteri Portföyü', description: 'Müşteri bilgileri ve ilişkili kayıtları yönetin.' },
      { title: 'Arama/Filtre', description: 'İhtiyacınız olan müşteri kayıtlarını hızla bulun.' },
      { title: 'İlişkili Kayıtlar', description: 'Biletler, servisler ve aktiviteleri takip edin.' },
    ];
  }
  // Unit
  if (seg[0] === 'unit') {
    if (seg.length >= 2) {
      return [
        { title: 'Ünite Detayı', description: 'Ünite bilgilerini ve bağlı kayıtları görüntüleyin.' },
        { title: 'İlişkilendirmeler', description: 'İş emirleri ve görevler ile ilişkilendirmeleri takip edin.' },
      ];
    }
    return [
      { title: 'Üniteler', description: 'Ünite listesini filtreleyin ve detaylara girin.' },
      { title: 'Detay', description: 'Ünite satırına tıklayarak detayını açın.' },
    ];
  }
  // Personellar
  if (startsWith('/calisanlar/')) {
    return [
      { title: 'Personellar', description: 'Personel listesini görüntüleyin ve arama/filtre yapın.' },
      { title: 'Detay', description: 'Personel satırına tıklayarak detayına gidin.' },
    ];
  }
  if (startsWith('/calisan-ekle/')) {
    return [
      { title: 'Personel Ekle', description: 'Yeni personel bilgilerini girerek sisteme ekleyin.' },
      { title: 'Alanlar', description: 'İsim, iletişim ve rol gibi alanları doldurun.' },
    ];
  }
  // Hesap
  if (startsWith('/account/')) {
    return [
      { title: 'Hesabım', description: 'Profil bilgilerinizi görüntüleyin ve düzenleyin.' },
      { title: 'Güvenlik', description: 'Şifre ve güvenlik ayarlarını yönetin.' },
    ];
  }
  // Giriş
  if (startsWith('/giris/')) {
    if (startsWith('/giris/unuttum/')) {
      return [
        { title: 'Şifre Unuttum', description: 'E-posta adresinizi girerek şifre sıfırlama bağlantısı alın.' },
      ];
    }
    if (startsWith('/giris/sifirla/')) {
      return [
        { title: 'Şifre Sıfırla', description: 'Yeni şifrenizi belirleyin ve giriş yapın.' },
      ];
    }
    return [
      { title: 'Giriş', description: 'Kullanıcı adı ve şifre ile sisteme giriş yapın.' },
    ];
  }
  // Sorgu
  if (startsWith('/sorgu/')) {
    return [
      { title: 'Sorgu', description: 'Veri sorgulama ekranında arama ve filtrelemeleri kullanın.' },
    ];
  }
  // Test
  if (startsWith('/test/')) {
    return [
      { title: 'Test Sayfası', description: 'Deneme ve geliştirme amaçlı içerikler.' },
    ];
  }
  if (startsWith('/tamamlanmis-is-emri/')) {
    return [
   { title: 'İş Emirleri', description: 'Bu sayfa, bitmiş olan işleri tablo şeklinde listeler.' },
      { title: 'Detay', description: 'Tablodaki ilgili satıra tıklayarak işin detaylarını görebilirsiniz.' },
    ];
  }
  if (startsWith('/gorevler/')) {
    return [
      { title: 'Görev Listesi', description: 'Atanan görevleri tablo veya kart görünümünde izleyin.' },
      { title: 'Durumlar', description: 'Bekleyen, devam eden, tamamlanan görev akışları.' },
      { title: 'Aksiyonlar', description: 'Görev detayını açın, düzenleyin veya ilerletin.' },
    ];
  }
  if (startsWith('/randevular/')) {
    return [
      { title: 'Randevular', description: 'Takvim ve zaman aralıklarını bu ekranda takip edin.',},
      { title: 'İlişkili Görev', description: 'Randevuya bağlı görev/iş emri detayına gidin.' },
    ];
  }
  
  if (startsWith('/bayi/')) {
    return [
      { title: 'Bayi Ağı', description: 'Hiyerarşik yapı ve bayi detaylarına erişin.' },
      { title: 'Takımlar', description: 'Bayiye bağlı takımları yönetin ve görüntüleyin.' },
      { title: 'İş Yükü', description: 'Açık iş emirleri ve istatistiklere göz atın.' },
    ];
  }
  if (startsWith('/musteriler/')) {
    return [
      { title: 'Müşteri Portföyü', description: 'Müşteri bilgileri ve ilişkili kayıtları yönetin.' },
      { title: 'Arama/Filtre', description: 'İhtiyacınız olan müşteri kayıtlarını hızla bulun.' },
      { title: 'İlişkili Kayıtlar', description: 'Biletler, servisler ve aktiviteleri takip edin.' },
    ];
  }

  // Varsayılan
  return [
    { title: 'Gezinti', description: 'Menüler ile uygulama içinde dolaşın.' },
    { title: 'Aksiyonlar', description: 'Sayfaya özel işlemleri üst/yan menülerde bulun.' },
    { title: 'Yardım', description: 'Öğreticiyi tekrar açarak kılavuza göz atın.' },
  ];
}